import React from 'react';
import { Link } from "gatsby"

export default function Layout({ element }) {
    return (
        <React.Fragment>
            <main role="main" className="container bg-white border p-0 site-shell">
                <nav className="navbar navbar-expand-lg navbar-light bg-light mb-3">
                    <Link className="navbar-brand" to="/">
                        <svg viewBox="0 0 365 60" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0%" style={{stopColor: "#2196F3", stopOpacity: 1}} />
                                    <stop offset="100%" style={{stopColor: "#1565C0", stopOpacity: 1}} />
                                </linearGradient>

                                <linearGradient id="lightGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0%" style={{stopColor: "#FFD54F", stopOpacity: 0.9}} />
                                    <stop offset="100%" style={{stopColor: "#FFA726", stopOpacity: 0.7}} />
                                </linearGradient>
                            </defs>

                            <g transform="translate(3, 7.5)">
                                <rect x="18" y="4.5" width="6" height="24" fill="url(#blueGradient)" rx="0.75" />
                                <rect x="12" y="10.5" width="18" height="6" fill="url(#blueGradient)" rx="0.75" />
                            </g>

                            <text x="45" y="30" fontFamily="'Montserrat', 'Arial', sans-serif" fontSize="24" fontWeight="700" fill="url(#blueGradient)" letterSpacing="6">
                                СВЕТ ЕВАНГЕЛИЯ
                            </text>

                            <text x="45" y="48" fontFamily="'Montserrat', 'Arial', sans-serif" fontSize="8.25" fontWeight="400" fill="#546E7A" letterSpacing="1.5">
                                ЦЕРКОВЬ ЕВАНГЕЛЬСКИХ ХРИСТИАН БАПТИСТОВ
                            </text>
                        </svg>
                    </Link>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item">
                                <Link className="nav-link" activeClassName="text-d-underline" to="/"><b>Главная</b></Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" activeClassName="text-d-underline" to="/questions"><b>Вопросы-ответы</b></Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" activeClassName="text-d-underline" to="/statement"><b>Вероучение</b></Link>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div className="main-content">
                    {element}
                </div>
                <div className="navbar-fixed-bottom row-fluid mt-4">
                    <div className="navbar-inner footer">
                        <div className="row no-gutters">
                            <div className="col-12">
                                <div className="mx-auto footer-info">
                                    <div className="footer-map">
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9409.12179018581!2d27.6112148!3d53.873442!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x4f03f3217b7f0655!2sGospel%20Light!5e0!3m2!1suk!2sua!4v1605038966362!5m2!1suk!2sua"
                                            title="Карта церкви Свет Евангелия"
                                            className="border-0"
                                            allowFullScreen=""
                                            aria-hidden="false"
                                            tabIndex="0" />
                                    </div>
                                    <div className="footer-contact">
                                        <p className="mt-sm-2 mb-0">
                                            Церковь "Свет Евангелия"<br />
                                            ул. Я. Райниса, 6, г. Минск, Беларусь<br />
                                            <br />
                                            Тел: +375 17 275 30 90
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </React.Fragment>
    )
}
